import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../../data/content";

export default function MarqueeStrip() {
  return (
    <section
      data-testid="marquee-strip"
      className="overflow-hidden border-y border-[var(--line)] bg-[#ffffff] py-8"
    >
      <Marquee speed={38} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-4xl italic text-[#1c2b4a] md:text-5xl">
              {w}
            </span>
            <span className="mx-10 text-[#9c7a33] md:mx-14">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
